export const highCourtMap = {
    0: "Select Highcourt",
    13: "Allahabad High Court",
    1: "Bombay High Court",
    16: "Calcutta High Court",
    6: "Gauhati High Court",
    29: "High Court for State of Telangana",
    2: "High Court of Andhra Pradesh",
    18: "High Court of Chhattisgarh",
    26: "High Court of Delhi",
    17: "High Court of Gujarat",
    5: "High Court of Himachal Pradesh",
    12: "High Court of Jammu and Kashmir",
    7: "High Court of Jharkhand",
    3: "High Court of Karnataka",
    4: "High Court of Kerala",
    23: "High Court of Madhya Pradesh",
    25: "High Court of Manipur",
    21: "High Court of Meghalaya",
    11: "High Court of Orissa",
    22: "High Court of Punjab and Haryana",
    9: "High Court of Rajasthan",
    24: "High Court of Sikkim",
    20: "High Court of Tripura",
    15: "High Court of Uttarakhand",
    10: "Madras High Court",
    8: "Patna High Court"
  };
  